let typeData = {
  // 文旅资讯
  'information': {
    'dictName': 'wlzxzxlx', // 词典
    'dictArr': [
      {'name': 'wlzxzxlx', 'param': 'infoType', 'data': '', 'descname': '资讯类型'}
    ]
  },
  // 活动报名
  'appointment': {
    'dictName': 'hdbmhdlx',
    'dictArr': [
      {'name': 'hdbmhdlx', 'param': 'activityType', 'data': '', 'descname': '活动类型'}
    ]
  },
  // 本地视听
  'live': {
    'dictName': 'bdstlx',
    'dictArr': [
      {'name': 'bdstlx', 'param': 'type', 'data': '', 'descname': '类型'}
    ]
  },
  // 票务预订
  'ticket': {
    'dictName': 'pwydlx,pwyddqlx',
    'dictArr': [
      {'name': 'pwydlx', 'param': 'type', 'data': '', 'descname': '类型'},
      {'name': 'pwyddqlx', 'param': 'areaType', 'data': '', 'descname': '地区类型'}
    ]
  },
  // 专题外链
  'culture': {
    'dictName': 'topicLinkType',
    'dictArr': [{'name': 'topicLinkType', 'param': 'type', 'data': '', 'descname': '类型'}]
  },
  // 群文展示
  'cultureshow': {
    'dictName': '',
    'dictArr': []
  },
  // 文化配送
  'culturedistribution': {
    'dictName': 'whpslx,whpsdqlx,whpscglx',
    'dictArr': [
      {'name': 'whpslx', 'param': 'distributionType', 'data': '', 'descname': '类型'},
      {'name': 'whpsdqlx', 'param': 'areaType', 'data': '', 'descname': '地区类型'},
      {'name': 'whpscglx', 'param': 'venueType', 'data': '', 'descname': '场馆类型'}
    ]
  },
  // 文化地图
  'culturemap': {
    'dictName': 'whdtcdlx',
    'dictArr': [
      {'name': 'whdtcdlx', 'param': 'siteType', 'data': ''}
    ]
  },
  // 总分馆
  'pavilion': {
    'dictName': 'zfglx',
    'dictArr': [
      {'name': 'zfglx', 'param': 'type', 'data': '', 'descname': '类型'}
    ]
  },
  'digital': {
    'dictName': 'cgyldqlx,cgyllx',
    'dictArr': [
      {'name': 'cgyldqlx', 'param': 'areaType', 'data': ''},
      {'name': 'cgyllx', 'param': 'type', 'data': ''}
    ]
  }, // 场馆预览
  'venue': {
    'dictName': 'cgyddqlx,cgydlx',
    'dictArr': [
      {'name': 'cgyddqlx', 'param': 'areaType', 'data': ''},
      {'name': 'cgydlx', 'param': 'type', 'data': ''}
    ]
  }, // 场馆预订
  'delicacy': {
    'dictName': 'tsmsdqlx,tsmsmslx',
    'dictArr': [
      {'name': 'tsmsdqlx', 'param': 'areaType', 'data': '', 'descname': '地区类型'},
      {'name': 'tsmsmslx', 'param': 'foodType', 'data': '', 'descname': '美食类型'}
    ]
  }, // 美食
  'scenicspot': {
    'dictName': 'scenicSpotAreaType,scenicSpotSubject',
    'dictArr': [
      {'name': 'scenicSpotAreaType', 'param': 'areaType', 'data': '', 'descname': '地区类型'},
      {'name': 'scenicSpotSubject', 'param': 'subject', 'data': '', 'descname': '主题类型'}
    ]
  }, // 景点
  'touristmarket': {
    'dictName': 'touristMarketAreaType,touristMarketProductType',
    'dictArr': [
      {'name': 'touristMarketAreaType', 'param': 'areaType', 'data': '', 'descname': '地区类型'},
      {'name': 'touristMarketProductType', 'param': 'productType', 'data': '', 'descname': '商品类型'}
    ]
  }, // 旅游集市
  'homestayhotel': {
    'dictName': 'hotelAreaType,hotelType,hotelLabel,hotelFacilityService',
    'dictArr': [
      {'name': 'hotelAreaType', 'param': 'areaType', 'data': '', 'descname': '地区类型'},
      {'name': 'hotelType', 'param': 'hotelType', 'data': '', 'descname': '酒店类型'},
      {'name': 'hotelLabel', 'param': 'hotelLabel', 'data': '', 'descname': '标签'},
      {'name': 'hotelFacilityService', 'param': 'facilityService', 'data': '', 'descname': '服务设施'}
    ]
  }, // 民宿酒店
  'travelguide': {
    'dictName': 'jdbq',
    'dictArr': [
      {'name': 'jdbq', 'param': 'travelTags', 'data': '', 'descname': '推荐路线'}
    ]
  }, // 旅游攻略
  'culturalcommodity': {
    'dictName': 'culturalCommoditySubjectType,culturalCommodityProductType',
    'dictArr': [
      {'name': 'culturalCommoditySubjectType', 'param': 'subjectType', 'data': ''},
      {'name': 'culturalCommodityProductType', 'param': 'productType', 'data': ''}
    ]
  }, // 文创商城
  'workCollect': {
    'dictName': 'watlx',
    'dictArr': [
      {'name': 'watlx', 'param': 'activityType', 'data': '', 'descname': '活动类型'}
      // {'name': 'wwplx', 'param': 'subjectType', 'data': '', 'descname': '温馨提示'},
    ]
  }, // 作品征集
  // 积分商城
  'pointsmall': {
    'dictName': '', // 词典
    'dictArr': []
  },
  'newlive': {
    'dictName': 'whzbzblx,whzbfqdw',
    'dictArr': [
      {'name': 'whzbzblx', 'param': 'liveType', 'data': '', 'descname': '直播类型'},
      {'name': 'whzbfqdw',
        'param': 'unitType',
        'data': '',
        'descname': '发起单位'}
    ]
  },
  // 志愿者
  'volunteer': {
    'dictName': 'zyzzzmm,zyzfwlx,zyzfwqy',
    'dictArr': [
      {'name': 'zyzzzmm', 'param': 'politicalState', 'data': '', 'descname': '政治面貌'},
      {'name': 'zyzfwlx', 'param': 'serviceType', 'data': '', 'descname': '服务类型'},
      {'name': 'zyzfwqy', 'param': 'serviceArea', 'data': '', 'descname': '服务区域'}
    ]
  },
  // 志愿团队
  'volunteercommunity': {
    'dictName': '',
    'dictArr': []
  },
  // 志愿活动
  'volunteeractivity': {
    'dictName': '',
    'dictArr': []
  },
  // 服务风采
  'activitystyle': {
    'dictName': '',
    'dictArr': []
  },
  // 品牌活动
  'brandactivity': {
    'dictName': 'pphdlx',
    'dictArr': [
      {'name': 'pphdlx', 'param': 'type', 'data': '', 'descname': '类型'}
    ]
  },
  // 图片展示
  'exhibit': {
    'dictName': 'wwplx',
    'dictArr': [
      {'name': 'wwplx', 'param': 'type', 'data': '', 'descname': '类型'}
    ]
  }
}

export default typeData



// WEBPACK FOOTER //
// ./src/components/typescreen/typeconfig.js